const AccessRights = (current_page_permissions, mode = 'view', created_by = "") => {

   
    if (mode === 'view') {
        const viewAll = current_page_permissions.reporting_access_view_all;
        const viewIds = current_page_permissions.reporting_access_view_ids || [];

        if (
            current_page_permissions.rights_view &&
            (viewAll || viewIds.includes(created_by))
        ) {
            return true;
        }
    } else if (mode === 'edit') { 
        const editAll = current_page_permissions.reporting_access_edit_all;
        const editIds = current_page_permissions.reporting_access_edit_ids || [];
        if (
            current_page_permissions.rights_edit &&
            (editAll || editIds.includes(created_by))
        ) {  
            return true;
        }
    } else if (mode === 'delete') {
        const deleteAll = current_page_permissions.reporting_access_delete_all;
        const deleteIds = current_page_permissions.reporting_access_delete_ids || [];

        if (
            current_page_permissions.rights_delete &&
            (deleteAll || deleteIds.includes(created_by))
        ) {
            return true;
        }
    } else if (mode === 'add') {
        if (current_page_permissions.rights_add === 1) {
            return true;
        }
    }
    return false;
};

export default AccessRights;
